import styled, { css } from "styled-components";

import { colors } from "UI/colors";

import { addOpacity } from "Utilities/Colors/colorUtils";
import dynPaddingLeft from "Utilities/interpolations/dynPaddingLeft";
import dynPaddingRight from "Utilities/interpolations/dynPaddingRight";

const standardInputStyles = css`
  font-weight: 400;
  width: 100%;
  box-sizing: border-box;
  font-size: 1.125em;
  border-radius: 10px;
  border: 1px solid ${colors.fnBorderGray2};
  padding: 12px 16px;
  color: ${colors.fnInputBlack};
  outline: none;
  background: #fff;
  transition: box-shadow 0.6s;
  margin: 0;
  font-family: inherit;
  &:focus,
  &:hover {
    box-shadow: 0 0 0 1px ${addOpacity(colors.fnBlue, 0.71)};
    transition: box-shadow 0.2s;
  }
  ${dynPaddingLeft}
  ${dynPaddingRight}
`;

/** Add this to a styled component to make the standard input smaller. */
const smInputStyles = css`
  padding: 8px 12px;
`;

const DefaultInput = styled.input`
  ${standardInputStyles}
`;

export { standardInputStyles, smInputStyles };
export default DefaultInput;
